import * as ActionTypes from "./../ActionTypes";

export const SEARCH_USERS = (users = [], action) => {
    switch (action.type) {
        case ActionTypes.SEARCH:
            return action.payload;

        default:
            return users;
    }
}